var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBethistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.1333H4.96875C5.71875 11.6628 7.10625 12.7712 8.75 13.1543V16.4667H4.375V19H15.625V16.4667H11.25V13.1543C12.8938 12.7712 14.2812 11.6628 15.0312 10.1333H16.25C18.3219 10.1333 20 8.43283 20 6.33333V3.16667C20 2.46683 19.4406 1.9 18.75 1.9H15.625V0H4.375V1.9H1.25C0.559375 1.9 0 2.46683 0 3.16667V6.33333C0 8.43283 1.67812 10.1333 3.75 10.1333ZM17.5 4.43333V6.33333C17.5 7.03317 16.9406 7.6 16.25 7.6H15.625V4.43333H17.5ZM6.875 2.53333H13.125V7.6C13.125 9.348 11.725 10.7667 10 10.7667C8.275 10.7667 6.875 9.348 6.875 7.6V2.53333ZM2.5 4.43333H4.375V7.6H3.75C3.05938 7.6 2.5 7.03317 2.5 6.33333V4.43333Z",
    fill: "#FFBB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBethistory);
export default __webpack_public_path__ + "static/media/bethistory.82d79602cd7c8abca71ef6c77728e98d.svg";
export { ForwardRef as ReactComponent };